import { UserGreeting } from '@mint-lib/ai-chat/components';
import { useProfile } from '@mint-lib/profile-helpers';

const AgenticAiWelcomeMessage = () => {
  const { profile } = useProfile();

  return (
    <UserGreeting
      userName={profile?.profile?.firstName}
      className="h-16 w-74.5 pt-20"
    />
  );
};

export default AgenticAiWelcomeMessage;
